import PropTypes from 'prop-types';
import { isNilOrEmpty } from 'ramda-extension';

import fetch from 'features/common/fetch';

import PKUrl from './PKUrl';

const { pKPartner, pKPartnerUnlock } = fetch.constants.urls;

export const PKPartner = ({
	partnerId,
	children,
	unlock,
	communicationCode,
	campaignEndDate,
	taskId,
	muiLink = false,
}) => {
	const getUnlockArgs = () => {
		if (unlock) {
			return !isNilOrEmpty(taskId) ? { taskId } : { communicationCode, campaignEndDate };
		} else {
			return null;
		}
	};

	const url = unlock ? pKPartnerUnlock : pKPartner;
	const unlockArgs = getUnlockArgs();

	if (!partnerId) return children;
	return (
		<PKUrl url={url} fetchArgs={{ partnerId, ...unlockArgs }} doNotPreloadIascLink muiLink={muiLink}>
			{children}
		</PKUrl>
	);
};

PKPartner.propTypes = {
	campaignEndDate: PropTypes.string,
	children: PropTypes.any,
	communicationCode: PropTypes.number,
	muiLink: PropTypes.bool,
	partnerId: PropTypes.number,
	taskId: PropTypes.number,
	unlock: PropTypes.bool,
};

export default PKPartner;
